/*
  Bundle page contract — follow this when adding a new product to the page:
    • Each product card has: id="card-{key}", data-variant-id, data-price, data-available
    • Each variant button has: id="rmv-btn-{key}", data-variant-id, data-price,
      data-available, data-parent-card="#card-{parentKey}"
    • Sold-out behavior is driven entirely by the data-available attribute.
      Adding a new product (with or without variants) only requires following
      the markup pattern above — no edits to the toggle/addToCart guards needed.
    • Per-item strikethrough math: getItemPrice() reads the regular price from
      data-price, DISCOUNTS maps item count → discount rate, and getBundlePrice()
      applies Shopify's per-line cent rounding (floor on discount cents) so the
      bundle panel preview matches the cart drawer / cart page to the cent.
    • Discount source: cart discounts are applied by Shopify automatic discounts
      in admin (BUNDLE-X%OFF), not by this file. Keep the DISCOUNTS map above in
      sync with the admin percentages. The _DISCOUNT line item property set in
      addToCart() is purely visual — its value is the pack size ('3-pack'), not
      a percentage, and drives the bundle-tier-{N} CSS classes in
      component-cart.css. Percentages live only in the DISCOUNTS map, the admin
      discounts, and the hardcoded copy in EL-bundle-page-link.liquid and
      EL-bundle-hero.liquid.
    • WebView fallback: addToCart()'s .catch() branch navigates the customer to a
      cart permalink (/cart/{v1}:1,...) so restricted in-app browsers (TikTok, IG,
      FB, iOS Mail) still land them on checkout with the bundle added. This store
      is configured to skip /cart, so the destination is /checkouts/... . _DISCOUNT
      visual labels are lost on that path (permalinks don't accept properties);
      the auto-discount price still applies via admin. Do not remove the
      responseReceived flag or the .catch() branching — see the comment above the
      fetch chain and feature-cart-webview-fallback-bundle for the full story.
*/

const PRODUCTS = {
  'rm-v1': {name:'Roll & Match Game - Original Theme', imgId:'card-rm'},
  'rm-v2': {name:'Roll & Match Game - Classic Theme', imgId:'card-rm'},
  'rm-v3': {name:'Roll & Match Game - Legacy Theme', imgId:'card-rm'},
  idea: {name:'I.D.E.A. Farm: 3-in-1', imgId:'card-idea'},
  wws:  {name:'Wise Whiz: Logic & Memory', imgId:'card-wws'},
  bingo:{name:'Bingo - Animal Frenzy', imgId:'card-bingo'},
};
const MAX_BUNDLE_ITEMS = 5;
const DISCOUNTS = {2:0.10, 3:0.12, 4:0.14, 5:0.15};
let selected = new Set();
let selectedVariantIds = [];

function getImg(id){return document.querySelector('#card-'+id+' .product-img-wrap img').src}

function scrollCardIntoView(targetEl,behavior='smooth'){
  if(!targetEl||window.innerWidth>900){
    return;
  }

  window.requestAnimationFrame(()=>{
    const top=targetEl.getBoundingClientRect().top+window.scrollY-12;
    window.scrollTo({top,behavior});
  });
}

function syncMobileStickyBar(){
  const mobileBar=document.getElementById('bundle-progress-mobile');
  const sectionTitle=document.querySelector('.products-col .section-title');
  if(!mobileBar||!sectionTitle){
    return;
  }

  if(window.innerWidth>900){
    mobileBar.classList.remove('is-visible');
    return;
  }

  const titleRect=sectionTitle.getBoundingClientRect();
  const viewportMidpoint=window.innerHeight/2;
  mobileBar.classList.toggle('is-visible',titleRect.top<=viewportMidpoint);
}

function getProductCardId(id){
  return id.startsWith('rm-v') ? 'card-rm' : 'card-'+id;
}

function getVariantId(id){
  const el=id.startsWith('rm-v')
    ? document.getElementById('rmv-btn-'+id)
    : document.getElementById(getProductCardId(id));
  return el?.dataset.variantId||'';
}

function getItemPrice(id){
  const el=id.startsWith('rm-v')
    ? document.getElementById('rmv-btn-'+id)
    : document.getElementById(getProductCardId(id));
  return Number(el?.dataset.price||0);
}

function getBundlePrice(price,rate){
  const priceCents=Math.round(price*100);
  const discountCents=Math.floor(priceCents*rate);
  return (priceCents-discountCents)/100;
}

function syncSelectedVariantIds(){
  selectedVariantIds=[...selected].map(getVariantId).filter(Boolean);
}

function syncRollMatchState(){
  const card=document.getElementById('card-rm');
  const panel=document.getElementById('rm-variant-panel');
  const bundleSummaryArea=document.getElementById('bundle-summary-area');
  if(!card||!panel)return;

  const hasVariants=[...selected].some(id=>id.startsWith('rm-v'));
  card.classList.toggle('selected',hasVariants);
  panel.classList.toggle('open',card.classList.contains('variant-open'));
  if(bundleSummaryArea){
    bundleSummaryArea.classList.toggle('rm-variants-open',card.classList.contains('variant-open'));
  }
}

function toggleRollMatch(event){
  if(event)event.stopPropagation();
  const card=document.getElementById('card-rm');
  if(!card||card.dataset.available==='false')return;
  const willOpen=!card.classList.contains('variant-open');
  card.classList.toggle('variant-open');
  syncRollMatchState();
  if(willOpen&&window.innerWidth<=900){
    const scrollTarget=card.querySelector('.product-info .prod-desc')||card;
    scrollCardIntoView(scrollTarget);
  }
}

function toggleVariant(id,event){
  if(event)event.stopPropagation();
  const btn=document.getElementById('rmv-btn-'+id);
  if(!btn||btn.dataset.available==='false')return;
  const isRemoving=selected.has(id);

  if(isRemoving){
    selected.delete(id);
    btn.classList.remove('selected');
  }else{
    if(selected.size>=MAX_BUNDLE_ITEMS){showToast(`Maximum ${MAX_BUNDLE_ITEMS} games per bundle`,'');return}
    selected.add(id);
    btn.classList.add('selected');
  }

  const card=document.getElementById('card-rm');
  if(card){
    if([...selected].some(key=>key.startsWith('rm-v'))){
      card.classList.add('variant-open');
    }
  }

  syncSelectedVariantIds();
  syncRollMatchState();
  updatePanel();

  if(card&&!isRemoving){
    const scrollTarget=card.querySelector('.product-info .prod-desc')||card;
    scrollCardIntoView(scrollTarget,'auto');
  }
}

function toggleProduct(id){
  const card = document.getElementById(getProductCardId(id));
  if(!card||card.dataset.available==='false')return;
  const isRemoving=selected.has(id);
  if(isRemoving){selected.delete(id);card.classList.remove('selected')}
  else{
    if(selected.size>=MAX_BUNDLE_ITEMS){showToast(`Maximum ${MAX_BUNDLE_ITEMS} games per bundle`,'');return}
    selected.add(id);card.classList.add('selected')
  }
  syncSelectedVariantIds();
  syncRollMatchState();
  updatePanel();
  if(!isRemoving){
    scrollCardIntoView(card);
  }
}

function updatePanel(){
  const ids=[...selected], count=ids.length;
  const discRate=count>=2?(DISCOUNTS[count]||DISCOUNTS[MAX_BUNDLE_ITEMS]):0;
  document.getElementById('items-count').textContent=count+' of '+MAX_BUNDLE_ITEMS+' item'+(count!==1?'s':'');
  // document.getElementById('mobile-items-count').textContent=count+' of '+MAX_BUNDLE_ITEMS+' item'+(count!==1?'s':'');
  document.getElementById('progress-fill').style.width=(count/MAX_BUNDLE_ITEMS*100)+'%';
  document.getElementById('mobile-progress-fill').style.width=(count/MAX_BUNDLE_ITEMS*100)+'%';
  if(count===0){
    document.getElementById('progress-text').textContent='Add 2 more games to start saving';
    document.getElementById('progress-pct').textContent='';
    document.getElementById('mobile-progress-text').textContent='Add 2 more games to start saving';
    document.getElementById('mobile-progress-pct').textContent='';
  }
  else if(count===1){
    document.getElementById('progress-text').textContent='Add more to unlock bundle savings!';
    document.getElementById('progress-pct').textContent='1/'+MAX_BUNDLE_ITEMS;
    document.getElementById('mobile-progress-text').textContent='Add more to unlock bundle savings!';
    document.getElementById('mobile-progress-pct').textContent='1/'+MAX_BUNDLE_ITEMS;
  }
  else{
    const d=DISCOUNTS[count]||DISCOUNTS[MAX_BUNDLE_ITEMS];
    document.getElementById('progress-text').textContent='Bundle unlocked — '+(d*100).toFixed(0)+'% savings!';
    document.getElementById('progress-pct').textContent=count+'/'+MAX_BUNDLE_ITEMS;
    document.getElementById('mobile-progress-text').textContent='Bundle unlocked — '+(d*100).toFixed(0)+'% savings!';
    document.getElementById('mobile-progress-pct').textContent=count+'/'+MAX_BUNDLE_ITEMS;
  }

  const listEl=document.getElementById('bundle-items');
  if(count===0){
    listEl.innerHTML='';
    const e=document.createElement('div');e.className='bundle-empty';
    e.innerHTML='<div class="bundle-empty-text bundle-empty-text--desktop">Select games on the left<br>to build your bundle</div><div class="bundle-empty-text bundle-empty-text--mobile">Select games below<br>to build your bundle</div>';
    listEl.appendChild(e)
  }else{
    const displayIds=[...ids].reverse();
    listEl.innerHTML=displayIds.map(id=>{
      const p=PRODUCTS[id];
      const price=getItemPrice(id);
      return `<div class="bundle-item-row">
        <img src="${getImg(p.imgId.replace('card-',''))}" class="bundle-item-img" style="background:#F0F0F0" alt="${p.name}">
        <div class="bundle-item-name">${p.name}</div>
        ${count>=2
          ? `<div class="bundle-item-prices">
              <span class="bundle-item-price-orig" aria-label="Regular price, $${price.toFixed(2)}">$${price.toFixed(2)}</span>
              <span class="bundle-item-price" aria-label="Bundle price, $${getBundlePrice(price,discRate).toFixed(2)}">$${getBundlePrice(price,discRate).toFixed(2)}</span>
            </div>`
          : `<div class="bundle-item-prices">
              <span class="bundle-item-price">$${price.toFixed(2)}</span>
            </div>`
        }
        <button class="bundle-item-remove" onclick="event.stopPropagation();${id.startsWith('rm-v') ? `toggleVariant('${id}', event)` : `toggleProduct('${id}')`}">×</button>
      </div>`
    }).join('')
  }

  const origTotal=ids.reduce((s,id)=>s+getItemPrice(id),0);
  const discount=count>=2
    ? ids.reduce((s,id)=>s+Math.floor(Math.round(getItemPrice(id)*100)*discRate),0)/100
    : 0;
  const bundleTotal=origTotal-discount;
  const freeShip=bundleTotal>=50;

  const savingsEl=document.getElementById('bundle-savings');
  const bannerEl=document.getElementById('savings-banner');
  const shipRow=document.getElementById('ship-label').closest('.savings-row');
  if(count>=2){
    savingsEl.classList.add('show');bannerEl.classList.add('show');
    document.getElementById('orig-total').textContent='$'+origTotal.toFixed(2);
    document.getElementById('discount-label').textContent='−$'+discount.toFixed(2);
    shipRow.style.display=freeShip?'flex':'none';
    document.getElementById('ship-label').textContent='FREE ✓';
    document.getElementById('ship-label').style.color='var(--green)';
    document.getElementById('bundle-total-label').textContent=freeShip?'Bundle total':'Bundle subtotal';
    document.getElementById('bundle-total').textContent='$'+bundleTotal.toFixed(2);
    document.getElementById('save-amount').textContent='$'+discount.toFixed(2);
    document.getElementById('save-pct').textContent=(discRate*100).toFixed(0)+'% off'
  }else{
    savingsEl.classList.remove('show');bannerEl.classList.remove('show');
    shipRow.style.display='flex';
    document.getElementById('bundle-total-label').textContent='Bundle total';
  }

  const btn=document.getElementById('cta-btn'),hint=document.getElementById('cta-hint');
  const mobileBtn=document.getElementById('mobile-cta-btn');
  const cartIconSvg='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>';
  if(count>=2){
    btn.disabled=false;
    btn.innerHTML=`${cartIconSvg}Add Bundle to Cart · $${bundleTotal.toFixed(2)}`;
    if(mobileBtn){
      mobileBtn.disabled=false;
      mobileBtn.innerHTML=`${cartIconSvg}Add Bundle to Cart · $${bundleTotal.toFixed(2)}`;
    }
    hint.innerHTML=freeShip?'<span>✓ Free shipping included!</span>':'Add more to unlock <span>free shipping</span>'
  }else{
    btn.disabled=true;
    btn.innerHTML=`${cartIconSvg}Add Bundle to Cart`;
    if(mobileBtn){
      mobileBtn.disabled=true;
      mobileBtn.innerHTML=`${cartIconSvg}Add Bundle to Cart`;
    }
    hint.innerHTML='Select <span>at least 2 games</span> to unlock your bundle'
  }
}

function addToCart(){
  const droppedIds=[];
  for(const id of [...selected]){
    const el=id.startsWith('rm-v')
      ? document.getElementById('rmv-btn-'+id)
      : document.getElementById(getProductCardId(id));
    if(!el||el.dataset.available==='false'){
      selected.delete(id);
      droppedIds.push(id);
    }
  }
  if(droppedIds.length){
    syncSelectedVariantIds();
    syncRollMatchState();
    updatePanel();
    showToast('Some items are no longer available — please review your bundle.','');
    return;
  }
  const ids=[...selected];if(ids.length<2)return;
  const count=ids.length,disc=DISCOUNTS[count]||DISCOUNTS[MAX_BUNDLE_ITEMS];
  const bundleLabel=count+'-pack';
  const cart=document.querySelector('cart-notification')||document.querySelector('cart-drawer');
  const payload={
    items:selectedVariantIds.map(id=>({
      id,
      quantity:1,
      properties:{_DISCOUNT:bundleLabel}
    }))
  };

  if(cart&&typeof cart.getSectionsToRender==='function'){
    payload.sections=cart.getSectionsToRender().map(section=>section.id);
    payload.sections_url=window.location.pathname;
    if(typeof cart.setActiveElement==='function')cart.setActiveElement(document.activeElement);
  }

  // Restricted in-app browsers (TikTok, IG, FB, iOS Mail) silently break the JS cart flow.
  // Two failure modes: fetch never reached the server (network / CORS / cookie blocked),
  // or fetch succeeded and response processing failed. Only use the permalink fallback in
  // the first case — otherwise items are already in the cart and re-adding via permalink
  // would double them. On this store the cart is configured to skip straight to /checkout,
  // so both branches land the customer on checkout ready to pay.
  let responseReceived=false;

  fetch(`${window.Shopify.routes.root}cart/add.js`,{
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify(payload)
  })
    .then(response=>{
      responseReceived=true;
      if(!response.ok)throw new Error('Failed to add bundle variant to cart');
      return response.json();
    })
    .then(data=>{
      if(cart&&typeof cart.renderContents==='function'&&data.sections){
        if(cart.classList.contains('is-empty'))cart.classList.remove('is-empty');
        cart.renderContents(data);
      }
      showToast('Bundle added! '+(disc*100).toFixed(0)+'% savings applied','');
    })
    .catch(e=>{
      console.error('Bundle add failed, falling back to cart permalink navigation:',e);
      if(responseReceived){
        window.location.assign(`${window.Shopify.routes.root}cart`);
      }else{
        const permalink=selectedVariantIds.map(id=>`${id}:1`).join(',');
        window.location.assign(`${window.Shopify.routes.root}cart/${permalink}`);
      }
    });
}

function showToast(msg,icon){
  const t=document.getElementById('toast');
  document.getElementById('toast-msg').textContent=msg;
  document.getElementById('toast-icon').textContent=icon||'';
  t.classList.add('show');setTimeout(()=>t.classList.remove('show'),3500)
}

window.toggleRollMatch=toggleRollMatch;
window.toggleVariant=toggleVariant;
window.toggleProduct=toggleProduct;
window.addToCart=addToCart;

document.addEventListener('DOMContentLoaded',()=>{
  syncSelectedVariantIds();
  syncRollMatchState();
  updatePanel();
  syncMobileStickyBar();
  window.addEventListener('scroll',syncMobileStickyBar,{passive:true});
  window.addEventListener('resize',syncMobileStickyBar);
});
